import { FC, MouseEvent, useState } from 'react'
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Icon,
} from '@mui/material'
import { AddOutlined } from '@mui/icons-material'
import capitalize from 'lodash/capitalize'
import { useTranslation } from 'react-i18next'

import { Filters, FilterType } from './Helper'
import { isMobileView } from 'lib/GlobalConstants'
import { useAppSelector } from 'redux/Hook'

interface FilterMenuProps {
  filters: Filters
  onFilterSelect: (filter: FilterType) => void
}

const FilterMenu: FC<FilterMenuProps> = ({ filters, onFilterSelect }) => {
  const { t } = useTranslation()
  const {
    contributions: {
      allContributions: { fetching },
    },
  } = useAppSelector((state) => state.textAnalysis.main)

  const [filterMenuAnchorElement, setFilterMenuAnchorElement] =
    useState<null | HTMLElement>(null)
  const open = Boolean(filterMenuAnchorElement)

  const handleMenuClose = () => {
    setFilterMenuAnchorElement(null)
  }

  const handleButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
    setFilterMenuAnchorElement(e.currentTarget)
  }

  return (
    <>
      <Button
        id="addFilter"
        variant="outlined"
        disabled={fetching}
        startIcon={<AddOutlined />}
        onClick={handleButtonClick}
        size={isMobileView ? 'small' : 'medium'}
        sx={{ color: 'primary.dark' }}
      >
        {t('textAnalysis.filters.title')}
      </Button>
      <Menu
        open={open}
        id="addFilter-menu"
        anchorEl={filterMenuAnchorElement}
        onClose={handleMenuClose}
        MenuListProps={{
          'aria-labelledby': 'addFilter',
          role: 'listbox',
        }}
      >
        {Object.keys(filters).map((filter) => {
          const { label, icon, visible } = filters[filter]

          return (
            <MenuItem
              key={filter}
              disabled={visible}
              value={capitalize(filter)}
              onClick={() => {
                onFilterSelect(filter)
                handleMenuClose()
              }}
            >
              {icon ? (
                <ListItemIcon>
                  <Icon>{icon}</Icon>
                </ListItemIcon>
              ) : null}
              <ListItemText>{label}</ListItemText>
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}

export default FilterMenu
